import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { DocumentoModel } from 'src/app/core/models/documento.model';
import { VehiculoModel } from 'src/app/core/models/vehiculo.model';
import { take } from 'rxjs/operators';
import { UserModel } from 'src/app/core/models/user.model';
import { BaseComponent } from '../../area-privada/components/base/base.component';
import { UserService } from 'src/app/core/services/user.service';
import { TranslateService } from '@ngx-translate/core';
import { VehiculosService } from 'src/app/core/services/vehiculos.service';
import { DocumentoService } from 'src/app/core/services/documento.service';
import { TipoDocumentoModel } from 'src/app/core/models/tipo-documento.model';
import { MenuItem } from 'primeng/api';
import { Router } from '@angular/router';
import { NbAuthResult, NbAuthService } from '@nebular/auth';

@Component({
  selector: 'dum-registro-total',
  templateUrl: './registro-total.component.html',
  styleUrls: ['./registro-total.component.scss']
})
export class RegistroTotalComponent extends BaseComponent implements OnInit {

  usuarioNuevo: UserModel = new UserModel();
  vehiculoNuevo: VehiculoModel = new VehiculoModel();
  documentacionVehiculo: DocumentoModel[] = [];
  mostrarFinalizar: boolean = false;
  mostrar1: boolean = true;
  mostrar2: boolean = false;
  mostrar3: boolean = false;
  isAllDocuments: boolean;
  hasVehiculo: boolean = false;

  newDocumentos: File[] = [];

  indiceActivo: number = 0;

  items: MenuItem[];

  // Estos tres los uso para inicializar
  documentos: DocumentoModel[] = [];
  tipoDocumentoNewDocumento: TipoDocumentoModel;
  visibleAddDocumento: boolean = false;
  isVehiculoMenor12TN: boolean;

  constructor(
    private userService: UserService,
    private vehiculoService: VehiculosService,
    private documentoService: DocumentoService,
    private router: Router,
    private authService: NbAuthService,
    private translateService: TranslateService
  ) {
    super(
    );
  }

  ngOnInit(): void {
    this.items = [{
      label: 'Datos Usuario',
      command: () => {
        if (this.usuarioNuevo.nif) {
          this.mostrar1 = true;
          this.mostrar2 = false;
          this.mostrar3 = false;
          this.mostrarFinalizar = false;
          this.indiceActivo = 0;
        }

      }
    },
    {
      label: 'Datos Vehículo',
      disabled: this.hasVehiculo,
      command: () => {
        if (this.vehiculoNuevo.matricula) {
          this.mostrar1 = false;
          this.mostrar2 = true;
          this.mostrar3 = false;
          this.mostrarFinalizar = false;
          this.indiceActivo = 1;
        }

      }
    },
    {
      label: 'Documentación del Vehículo',
      disabled: this.hasVehiculo,
      command: () => {
        if (this.documentos.length !== 0) {
          this.mostrar1 = false;
          this.mostrar2 = false;
          this.mostrar3 = true;
          this.mostrarFinalizar = false;
          this.indiceActivo = 2;
        }
      }
    },
    {
      label: 'Confirmación',
    }
    ];
  }

  recibirUsuario(usuario: UserModel) {
    if (this.hasVehiculo) {
      this.usuarioNuevo = usuario;
      this.mostrar1 = false;
      this.mostrar2 = true;
      this.indiceActivo = 1;
    } else {
      this.indiceActivo = 3;
      this.mostrar1 = false;
      this.mostrar3 = false;
      this.mostrarFinalizar = true;
    }
  }

  recibirVehiculo(vehiculo: VehiculoModel) {
    this.isVehiculoMenor12TN = vehiculo.tipoVehiculo.id === 3;
    this.vehiculoNuevo = vehiculo;
    this.mostrar2 = false;
    this.mostrar3 = true;
    this.indiceActivo = 2;
  }

  recibirAnteriorUsuario(mostrar: boolean) {
    if (mostrar) {
      this.mostrar2 = false;
      this.mostrar1 = true;
      this.indiceActivo = 0;
    }
  }

  recibirAnteriorVehiculo(mostrar: boolean) {
    if (mostrar) {
      this.mostrar3 = false;
      this.mostrar2 = true;
      this.indiceActivo = 2;
    }
  }

  recibirArchivos(newDocumentacion: File[]) {
    this.newDocumentos = newDocumentacion;
    this.indiceActivo = 3;
  }

  recibirDocumentacion(documentacion: DocumentoModel[]) {
    this.indiceActivo = 3;
    this.documentos = documentacion;
    this.mostrar3 = false;
    this.mostrarFinalizar = true;
  }

  getIsAllDocuments(event) {
    this.isAllDocuments = event;
  }

  saveUser() {
    // Anado el usuario
    this.userService.save(this.usuarioNuevo)
      .pipe(take(1))
      .subscribe((user) => {
        this.usuarioNuevo.id = user.id;
        this.authService.authenticate('email', { email: this.usuarioNuevo.email, password: this.usuarioNuevo.password })
          .subscribe((result: NbAuthResult) => {
            if (result.isSuccess()) {
              if (this.hasVehiculo) {
                this.registroVehiculo();
              } else {
                this.dumToast.add({ severity: 'success', summary: this.translateService.instant('REGISTRO.COMPLETADO'), detail: `${this.translateService.instant('REGISTRO.COMPLETADO.MSG.EXITO')}` });
                this.router.navigate(['area-privada']);
              }
            }
          });
      },
      (error) => {
        this.dumToast.add({severity: 'error', summary: this.translateService.instant('GLOBAL.CREACION.USUARIO'), detail: error.error.message});
      });

  }

  registroVehiculo() {
    this.vehiculoService.save(this.vehiculoNuevo)
      .pipe(take(1))
      .subscribe((vehiculo) => {
        this.vehiculoNuevo = vehiculo;
        this.anadirDocumentos();
        this.dumToast.add({ severity: 'success', summary: this.translateService.instant('REGISTRO.COMPLETADO'), detail: `${this.translateService.instant('REGISTRO.COMPLETADO.MSG.EXITO')}` });
      }, (error) => {
        this.dumToast.add({severity: 'error', summary: this.translateService.instant('GLOBAL.CREACION.VEHICULO'), detail: error.error.message});
      });


  }
  anadirDocumentos() {
    this.documentos.forEach((documento, key) => {
      this.documentoService.saveDocumento(this.vehiculoNuevo.id, documento.fechaVencimiento, documento.tipoDocumento.id, this.newDocumentos[documento.tipoDocumento.nombre])
        .pipe(take(1))
        .subscribe((newDocumento) => {
          this.tipoDocumentoNewDocumento = undefined;
          if ((this.documentos.length - 1) === key) {
            this.router.navigate(['area-privada']);
          }
        });
    });
  }

  eventHasVehiculo(hasVehiculo: boolean) {
    this.hasVehiculo = hasVehiculo;
  }
}
